module.exports = __webpack_public_path__ + "static/media/kn.ebd61713.jpeg";